import { render, staticRenderFns } from "./DatabaseIcon.vue?vue&type=template&id=18b55b2f&scoped=true&"
import script from "./DatabaseIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DatabaseIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b55b2f",
  null
  
)

export default component.exports